import styles from './ProcessStep.module.scss'
import Image from 'next/image'
import classNames from 'classnames'
import { useRef, useEffect } from 'react'
import { PortableText } from '@portabletext/react'
import { imgUrl } from '@bww/beke-lib/sanity-client'

export default function ProcessStep({
  stepNumber,
  id,
  title,
  headline,
  body,
  img,
  observer,
}) {
  const ref = useRef(null)

  useEffect(() => {
    if (observer !== undefined) {
      const cachedRef = ref.current
      observer?.observe(cachedRef)
      return () => {
        observer?.unobserve(cachedRef)
      }
    }
  }, [observer])

  return (
    <section id={id} className={styles.processStep} ref={ref}>
      <div className="container">
        <div className={styles.imageWrapper}>
          <Image
            className={styles.stepImage}
            src={
              img
                ? imgUrl(img).size(1160, 1160).fit('crop').url()
                : 'https://via.placeholder.com/1160.jpg'
            }
            width={580}
            height={580}
            alt={headline}
          />
        </div>
        <div className={styles.stepContent}>
          <header>
            <div className={classNames(styles.stepHeading, 'capText')}>
              Step {stepNumber}
            </div>
            <h2 className={classNames(styles.stepTitle, 'h5')}>{title}</h2>
          </header>
          <h3 className={classNames(styles.stepHeadline, 'h2')}>{headline}</h3>
          {body && <PortableText value={body} />}
        </div>
      </div>
    </section>
  )
}
